import { HttpBackend, HttpEvent, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from "@angular/core";
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpNoCacheBackend implements HttpBackend {
  httpbackend = inject(HttpBackend);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handle(req: HttpRequest<any>): Observable<HttpEvent<any>> {
    return this.httpbackend.handle(
      req.clone({
        setHeaders: {
          // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Cache-Control
          'Cache-Control': 'private, no-cache',
          Pragma: 'no-cache',
        },
      })
    );
  }
}
